// @flow
import { colors } from '../styleConfig'

export const { primary } = colors
export const { primaryLight } = colors
export const { primaryDark } = colors
export const { secondary } = colors
export const { secondaryLight } = colors
export const { secondaryDark } = colors

export const success = '#68D273'
export const error = '#E83E3E'

export const warnLight = '#FCF6E3'
export const warn = '#DEBA50'

export const white = '#FFFFFF'
export const gray100 = '#F3F3F3'
export const gray200 = '#D4D4D4'
export const gray300 = '#B5B6B6'
export const gray400 = '#969797'
export const gray500 = '#787879'
export const gray600 = '#59595A'
export const gray700 = '#3A3B3C'
export const black = '#1B1C1D'

export const lightRed = '#F75252'
export const red = '#EB3838'
export const darkRed = '#CC3131'



// WEBPACK FOOTER //
// ./src/style/constants/color.js